import React, { useEffect } from 'react'
import { Route, useLocation } from 'react-router-dom'
import Auth from '@aws-amplify/auth'
import { useSession, useAuthConfig } from './AuthProvider'

const Authenticate = () => {
  const location = useLocation()
  const authConfig = useAuthConfig()

  const redirectToKey = authConfig.afterAuthLocationCookieName
  const redirectToValue = `${location.pathname}${location.search}`
  window.localStorage.setItem(redirectToKey, redirectToValue)

  useEffect(() => {
    Auth.currentAuthenticatedUser()
      .catch(() => {
        authConfig.onAuthNeededRedirection({
          Auth,
          federatedSignInParams: { customState: redirectToKey },
          location
        })
      })
  }, [])

  return authConfig.LoadingAuthComponent
}

const PrivateRoute = ({
  element,
  allowedUserGroups,
  shouldShowStubbedPage = false,
  shouldCheckAuthentication = true,
  ...rest
}) => {
  const { isAuthenticated, session } = useSession()
  const authConfig = useAuthConfig()
  const userGroups = session?.accessToken?.payload?.['cognito:groups']?.join(',') || 'defaultUserGroup'
  const userHasApplicationAccess = userGroups.match(allowedUserGroups || authConfig.allowedUserGroups)?.length > 0

  // return the Authenticate component if not authenticated
  if (!isAuthenticated) {
    return <Route {...rest} element={<Authenticate />} />
  }

  // return user no authorized component if user has no application access
  if (!userHasApplicationAccess) {
    return <Route {...rest} element={authConfig.NotAuthorizedComponent} />
  }

  // return page
  return <Route {...rest} element={element} />
}

export default PrivateRoute
